import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
export default function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
   name: 'Elon Musk',
  position: 'CEO, Tesla & SpaceX',
  text: `AI doesn’t have to be a threat.
It’s a tool that, if aligned with human values,
can help us solve the most complex challenges of our time.`,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop'
    }
  ];

  // Auto-swipe every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <>
    <br />
<br />
<br />
    <div
      style={{
        width: '100%',
        height: '60vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #6A1DC2 100%)',
        backgroundSize: '400% 400%',
        animation: 'gradientMove 15s ease infinite',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            {/* Testimonial Content */}
            <div
              key={currentIndex}
              style={{
                animation: 'fadeIn 0.8s ease-in-out',
                textAlign: 'center',
                color: '#fff'
              }}
            >
              {/* Stars Rating */}
              <div style={{ marginBottom: '20px' }}>
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <span
                    key={i}
                    style={{
                      fontSize: '2rem',
                      color: '#FFD700',
                      marginRight: '5px'
                    }}
                  >
                    ★ ★ ★ ★ ★
                  </span>
                ))}
              </div>

              {/* Testimonial Text */}
              <p
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '400',
                  lineHeight: '1.8',
                  marginBottom: '30px',
                  fontStyle: 'italic',
                  color: '#fff'
                }}
              >
                "{testimonials[currentIndex].text}"
              </p>

              {/* Author Info */}
              <h4
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  marginBottom: '5px',
                  color: '#fff'
                }}
              >
                {testimonials[currentIndex].name}
              </h4>
              <p
                style={{
                  fontSize: '1.1rem',
                  fontWeight: '300',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                {testimonials[currentIndex].position}
              </p>
            </div>

            {/* Dots Indicator */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                marginTop: '40px'
              }}
            >
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  style={{
                    width: currentIndex === index ? '40px' : '12px',
                    height: '12px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: currentIndex === index 
                      ? '#fff' 
                      : 'rgba(255, 255, 255, 0.4)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    padding: 0
                  }}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
<br />
<br />
   </>

  );
}